export const DEFAULT_DATABASE_EMBED_SIZE = {
  width: 1200,
  height: 694,
};

export const DEFAULT_LARGE_EMBED_SIZE = {
  width: 1000,
  height: 694,
};

export const DEFAULT_NATIVE_DATABASE_EMBED_MIN_SIZE = {
  width: 850,
  height: 420,
};
